(() => {
  const STORAGE_KEY = 'zhyvago_shipping_address';

  /*
   * ========================================
   * 基本処理
   * ========================================
   */

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const formatMoney = (price) => {
    const amount = Number(price);

    if (amount === 0) {
      return '無料';
    }

    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      maximumFractionDigits: 0
    }).format(amount);
  };


  /*
   * ========================================
   * 配送先の保存
   * ========================================
   */

  function saveShippingAddress(container) {
    if (!container) return;

    const provinceInput = container.querySelector(
      '[data-shipping-province]'
    );

    const zipInput = container.querySelector(
      '[data-shipping-zip]'
    );

    if (!provinceInput || !zipInput) return;

    const data = {
      province: provinceInput.value || '',
      zip: zipInput.value || ''
    };

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(data)
      );
    } catch (error) {
      console.warn(
        '配送先を保存できませんでした。',
        error
      );
    }
  }


  /*
   * ========================================
   * 配送先の復元
   * ========================================
   */

  function restoreShippingAddress(container) {
    if (!container) return;

    try {
      const saved = localStorage.getItem(STORAGE_KEY);

const data = saved
  ? JSON.parse(saved)
  : {
      province: 'Okinawa',
      zip: '904-0115'
    };

      const provinceInput = container.querySelector(
        '[data-shipping-province]'
      );

      const zipInput = container.querySelector(
        '[data-shipping-zip]'
      );

      if (
        provinceInput &&
        data.province &&
        !provinceInput.value
      ) {
        provinceInput.value = data.province;
      }

      if (
        zipInput &&
        data.zip &&
        !zipInput.value
      ) {
        zipInput.value = data.zip;
      }

    } catch (error) {
      console.warn(
        '保存した配送先を読み込めませんでした。',
        error
      );
    }
  }


  function restoreAllShippingEstimators() {
    const containers = document.querySelectorAll(
      '[data-shipping-estimator]'
    );

    containers.forEach((container) => {
      restoreShippingAddress(container);
    });
  }


  /*
   * ========================================
   * Shopifyから送料を取得
   * ========================================
   */

  async function calculateShipping(container) {
    if (!container) return;

    const provinceInput = container.querySelector(
      '[data-shipping-province]'
    );

    const zipInput = container.querySelector(
      '[data-shipping-zip]'
    );

    const result = container.querySelector(
      '[data-shipping-estimator-result]'
    );

    const button = container.querySelector(
      '[data-shipping-estimator-submit]'
    );

    if (
      !provinceInput ||
      !zipInput ||
      !result ||
      !button
    ) {
      console.error(
        '送料計算に必要な要素が見つかりません。'
      );

      return;
    }

    const province = provinceInput.value;
    const rawZip = zipInput.value.trim();

    const zipDigits = rawZip.replace(/\D/g, '');

    /*
     * 入力チェック
     */

    if (!province) {
      result.textContent =
        '都道府県を選択してください。';

      return;
    }

    if (zipDigits.length !== 7) {
      result.textContent =
        '郵便番号を7桁で入力してください。';

      return;
    }

    /*
     * 配送先を保存
     */

    saveShippingAddress(container);

    /*
     * 1234567 → 123-4567
     */

    const zip =
      zipDigits.slice(0, 3) +
      '-' +
      zipDigits.slice(3);

    /*
     * 計算中表示
     */

    result.textContent =
      '送料を計算しています…';

    button.disabled = true;

    try {
      /*
       * Shopifyのルート取得
       */

      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      /*
       * 配送先パラメータ
       */

      const params = new URLSearchParams();

      params.append(
        'shipping_address[zip]',
        zip
      );

      params.append(
        'shipping_address[country]',
        'Japan'
      );

      params.append(
        'shipping_address[province]',
        province
      );

      const query = params.toString();

      /*
       * STEP 1
       * Shopifyに送料計算を開始させる
       */

      const prepareResponse = await fetch(
        `${root}cart/prepare_shipping_rates.json?${query}`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!prepareResponse.ok) {
        throw new Error(
          `送料計算の開始に失敗しました: ${prepareResponse.status}`
        );
      }

      /*
       * STEP 2
       * 計算結果が返るまで待つ
       */

      let shippingData = null;

      for (let i = 0; i < 20; i++) {
        await sleep(500);

        const response = await fetch(
          `${root}cart/async_shipping_rates.json?${query}`,
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          continue;
        }

        const data = await response.json();

        if (
          data &&
          Array.isArray(data.shipping_rates)
        ) {
          shippingData = data;

          break;
        }
      }

      if (!shippingData) {
        throw new Error(
          '送料計算がタイムアウトしました。'
        );
      }

      const rates =
        shippingData.shipping_rates || [];

      /*
       * 古い結果を削除
       */

      result.innerHTML = '';

      /*
       * 送料がない場合
       */

      if (rates.length === 0) {
        result.textContent =
          'この配送先に利用できる送料が見つかりませんでした。';

        return;
      }

      /*
       * ========================================
       * 最安送料のみ表示
       * ========================================
       */

      const cheapestRate = rates
        .slice()
        .sort(
          (a, b) =>
            Number(a.price) -
            Number(b.price)
        )[0];

      const row =
        document.createElement('div');

      row.className =
        'shipping-estimator__rate';

      const name =
        document.createElement('span');

      name.textContent =
        cheapestRate.presentment_name ||
        cheapestRate.name ||
        '配送';

      const price =
        document.createElement('strong');

      price.textContent =
        formatMoney(cheapestRate.price);

      row.appendChild(name);
      row.appendChild(price);

      result.appendChild(row);

    } catch (error) {
      console.error(
        '送料計算エラー:',
        error
      );

      result.textContent =
        '送料を取得できませんでした。時間をおいて再度お試しください。';

    } finally {
      /*
       * 必ずボタンを再度押せる状態に戻す
       */

      button.disabled = false;
    }
  }


  /*
   * ========================================
   * 「送料を計算」ボタン
   * ========================================
   */

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-shipping-estimator-submit]'
      );

      if (!button) return;

      event.preventDefault();

      const container = button.closest(
        '[data-shipping-estimator]'
      );

      if (!container) return;

      calculateShipping(container);
    }
  );


  /*
   * ========================================
   * 都道府県を変更したときも保存
   * ========================================
   */

  document.addEventListener(
    'change',
    (event) => {
      if (
        !event.target.matches(
          '[data-shipping-province]'
        )
      ) {
        return;
      }

      const container = event.target.closest(
        '[data-shipping-estimator]'
      );

      saveShippingAddress(container);
    }
  );


  /*
   * ========================================
   * 郵便番号入力後も保存
   * ========================================
   */

  document.addEventListener(
    'blur',
    (event) => {
      if (
        !event.target.matches(
          '[data-shipping-zip]'
        )
      ) {
        return;
      }

      const container = event.target.closest(
        '[data-shipping-estimator]'
      );

      saveShippingAddress(container);
    },
    true
  );


  /*
   * ========================================
   * カート内容変更時
   * ========================================
   */

  document.addEventListener(
    'cart:change',
    () => {
      document
        .querySelectorAll(
          '[data-shipping-estimator-result]'
        )
        .forEach((result) => {
          if (
            result.textContent.trim() !== ''
          ) {
            result.textContent =
              'カート内容が変更されました。送料を再計算してください。';
          }
        });

      /*
       * Prestigeがカートを再描画する時間を待って
       * 配送先を復元
       */

      setTimeout(() => {
        restoreAllShippingEstimators();
      }, 300);
    }
  );


  /*
   * ========================================
   * ページ読み込み時に配送先復元
   * ========================================
   */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        restoreAllShippingEstimators();
      }
    );
  } else {
    restoreAllShippingEstimators();
  }


  /*
   * ========================================
   * カートドロワーが再生成された場合にも復元
   * ========================================
   */

  const observer = new MutationObserver(
    (mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          /*
           * 追加された要素自体が送料計算欄
           */

          if (
            node.matches &&
            node.matches(
              '[data-shipping-estimator]'
            )
          ) {
            restoreShippingAddress(node);

            return;
          }

          /*
           * 追加された要素の中に送料計算欄がある場合
           */

          const containers =
            node.querySelectorAll
              ? node.querySelectorAll(
                  '[data-shipping-estimator]'
                )
              : [];

          containers.forEach(
            (container) => {
              restoreShippingAddress(
                container
              );
            }
          );
        });
      });
    }
  );

  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

})();